import { gql } from '@apollo/client';

export default gql`
  mutation DeleteUserById($id: Int!) {
    deleteUserById(input: { id: $id }) {
      deletedUserId
    }
  }
`;
